import { render, staticRenderFns } from "./ReportedIssueSolving.vue?vue&type=template&id=1d5b064c"
import script from "./ReportedIssueSolving.vue?vue&type=script&lang=ts"
export * from "./ReportedIssueSolving.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports